"use strict";
var noPagedPath = function () {
    if (window.location.pathname.includes('page/')) {
        var parts = window.location.pathname.split('page/');
        parts.pop();
        return parts.join('/');
    }
    return window.location.pathname;
};
function doSearch(event) {
    event.preventDefault();
    var searchParams = new URLSearchParams(window.location.search);
    if (event.target instanceof HTMLSelectElement) {
        if (event.target.matches('.archive-select')) {
            if (!event.target.value.toString().includes('all')) {
                var list = event.target.value.replace(window.location.origin + '/', '').split('/').filter(function (item) { return Number.isInteger(parseFloat(item)); });
                searchParams.set('date', list.join('-'));
            }
            else {
                searchParams.get('date') ? searchParams.delete('date') : false;
            }
        }
        if (event.target.matches('.cat-select')) {
            if (!event.target.value.toString().includes('all')) {
                searchParams.set('sort', event.target.value);
            }
            else {
                searchParams.get('sort') ? searchParams.delete('sort') : false;
            }
        }
    }
    if (event.target instanceof HTMLAnchorElement) {
        searchParams.set('sort', event.target.innerText.toLowerCase().replace(' ', '-'));
    }
    var params = searchParams.toString() !== '' ? "?" + searchParams.toString() : '';
    var newRelativePathQuery = noPagedPath() + params;
    window.location.href = newRelativePathQuery;
}
document.addEventListener('DOMContentLoaded', function () {
    var select = document.querySelector('.archive-select'), catSelect = document.querySelector('.cat-select'), cat = document.querySelectorAll('.cat-filter');
    if (select) {
        select.addEventListener('change', doSearch);
    }
    if (catSelect) {
        catSelect.addEventListener('change', doSearch);
    }
    if (cat) {
        Array.from(cat).forEach(function (el) { return el.addEventListener('click', doSearch); });
    }
});
